import React from 'react';
interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
}
export function FormSection({
  title,
  children,
  className = ''
}: FormSectionProps) {
  return <div className={`space-y-3 ${className}`} data-id="element-3919">
      <div className="flex items-center" data-id="element-3920">
        <div className="h-6 w-1 bg-teal-500 rounded-full mr-3" data-id="element-3921"></div>
        <h3 className="text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" data-id="element-3922">
          {title}
        </h3>
      </div>
      <div className="border border-gray-200 dark:border-gray-700 rounded-xl p-5 bg-white dark:bg-gray-800/50 shadow-sm" data-id="element-3923">
        {children}
      </div>
    </div>;
}